export const FETCH_FORM_VALUES = "FETCH_FORM_VALUES";
export const SELECT_DAY = 'SELECT_DAY';
